import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  avatar: {
    cursor: 'pointer',
  },

  menuContainer: {
    width: '200px',
  },
  menuItem: {},
}));
